import { render, staticRenderFns } from "./BusinessAreaList.vue?vue&type=template&id=a45d7fb6&scoped=true"
import script from "./BusinessAreaList.vue?vue&type=script&lang=js"
export * from "./BusinessAreaList.vue?vue&type=script&lang=js"
import style0 from "./BusinessAreaList.vue?vue&type=style&index=0&id=a45d7fb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45d7fb6",
  null
  
)

export default component.exports